import { z } from "@eisox/zod";

import { dayRangeSchema } from "~/helpers/day-range.helper";

import { GRANULARITY_ORDER, OBJECTIVE_PERCENT } from "../consumption.constant";
import { Comparison, ConsumptionTab, PeriodPreset } from "../types/consumption.type";

const objectivePercentSchema = z
  .number()
  .int()
  .min(OBJECTIVE_PERCENT.min)
  .max(OBJECTIVE_PERCENT.max)
  .multipleOf(OBJECTIVE_PERCENT.step);

const consumptionSearchSchema = z.object({
  tab: z.enum(ConsumptionTab).default(ConsumptionTab.CHART).catch(ConsumptionTab.CHART),
  preset: z.enum(PeriodPreset).optional().catch(undefined),
  range: dayRangeSchema.optional().catch(undefined),
  granularity: z.enum(GRANULARITY_ORDER).optional().catch(undefined),
  compare: z.enum(Comparison).default(Comparison.NONE).catch(Comparison.NONE),
  degreeDays: z.boolean().default(false).catch(false),
  objective: objectivePercentSchema.optional().catch(undefined),
});

type ConsumptionSearch = z.infer<typeof consumptionSearchSchema>;

export { consumptionSearchSchema, objectivePercentSchema };
export type { ConsumptionSearch };
